<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="13"
		height="12"
		viewBox="0 0 13 12"
		fill="none"
	>
		<path
			d="M6.079 0.529 C 5.963 0.572,5.895 0.626,5.817 0.735 L 5.753 0.827 5.747 3.068 C 5.743 4.300,5.737 5.308,5.731 5.308 C 5.726 5.308,4.924 4.829,3.950 4.243 C 2.672 3.475,2.145 3.168,2.061 3.147 C 1.704 3.054,1.372 3.399,1.473 3.758 C 1.529 3.956,1.534 3.960,3.459 5.115 C 4.454 5.712,5.265 6.203,5.261 6.206 C 5.257 6.210,4.455 6.692,3.478 7.279 C 2.500 7.866,1.669 8.370,1.630 8.399 C 1.472 8.519,1.412 8.771,1.496 8.966 C 1.606 9.224,1.898 9.343,2.149 9.232 C 2.200 9.209,3.027 8.718,3.987 8.141 L 5.731 7.093 5.742 9.131 L 5.753 11.169 5.802 11.250 C 6.008 11.581,6.459 11.585,6.662 11.257 L 6.728 11.151 6.733 9.119 L 6.739 7.087 8.510 8.151 C 9.484 8.736,10.312 9.228,10.351 9.244 C 10.436 9.280,10.585 9.282,10.684 9.249 C 10.861 9.189,10.998 9.016,11.020 8.826 C 11.036 8.691,10.966 8.496,10.874 8.419 C 10.839 8.389,10.018 7.890,9.050 7.309 C 8.083 6.729,7.273 6.243,7.252 6.228 C 7.218 6.205,7.442 6.064,9.007 5.125 C 10.344 4.322,10.824 4.024,10.891 3.952 C 11.148 3.680,11.013 3.242,10.642 3.143 C 10.444 3.089,10.455 3.083,8.539 4.237 C 7.559 4.826,6.754 5.308,6.749 5.308 C 6.743 5.308,6.736 4.306,6.733 3.080 L 6.728 0.852 6.662 0.746 C 6.541 0.550,6.282 0.454,6.079 0.529 "
			stroke="none"
			fill-rule="evenodd"
			fill="black"
		/>
	</svg>
</template>
